// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__M2_i0","error":"Textarea_error__3AdUu","readonly":"Textarea_readonly__4Ru5T","disabled":"Textarea_disabled__1-u8r"};